/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.CurriculumLevel_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.CurriculumLevel domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum CurriculumLevel_ {
   /// <summary>
   ///   Not Specified (NotSpec)
   /// </summary>
   NotSpecified = 0,
   /// <summary>
   ///   Toddler (Toddler)
   /// </summary>
   Toddler = 1,
   /// <summary>
   ///   Preschool (Prescho)
   /// </summary>
   Preschool = 2,
   /// <summary>
   ///   Kindergarten (Kind)
   /// </summary>
   Kindergarten = 3,
   /// <summary>
   ///   Grade 1 (Grade1)
   /// </summary>
   Grade1 = 4,
   /// <summary>
   ///   Grade 2 (Grade2)
   /// </summary>
   Grade2 = 5,
   /// <summary>
   ///   Grade 3 (Grade3)
   /// </summary>
   Grade3 = 6,
   /// <summary>
   ///   Grade 4 (Grade4)
   /// </summary>
   Grade4 = 7,
   /// <summary>
   ///   Grade 5 (Grade5)
   /// </summary>
   Grade5 = 8,
   /// <summary>
   ///   Grade 6 (Grade6)
   /// </summary>
   Grade6 = 9
}

export const CurriculumLevels: CurriculumLevel[] = [
   {
      code: CurriculumLevel_.NotSpecified,
      literal: 'NotSpecified',
      description: 'Not Specified',
      shortDescription: 'NotSpec',
      listPriority: 0,

      typeName: "CurriculumLevel"
   },
   {
      code: CurriculumLevel_.Toddler,
      literal: 'Toddler',
      description: 'Toddler',
      shortDescription: 'Toddler',
      listPriority: 1,

      typeName: "CurriculumLevel"
   },
   {
      code: CurriculumLevel_.Preschool,
      literal: 'Preschool',
      description: 'Preschool',
      shortDescription: 'Prescho',
      listPriority: 2,

      typeName: "CurriculumLevel"
   },
   {
      code: CurriculumLevel_.Kindergarten,
      literal: 'Kindergarten',
      description: 'Kindergarten',
      shortDescription: 'Kind',
      listPriority: 3,

      typeName: "CurriculumLevel"
   },
   {
      code: CurriculumLevel_.Grade1,
      literal: 'Grade1',
      description: 'Grade 1',
      shortDescription: 'Grade1',
      listPriority: 4,

      typeName: "CurriculumLevel"
   },
   {
      code: CurriculumLevel_.Grade2,
      literal: 'Grade2',
      description: 'Grade 2',
      shortDescription: 'Grade2',
      listPriority: 5,

      typeName: "CurriculumLevel"
   },
   {
      code: CurriculumLevel_.Grade3,
      literal: 'Grade3',
      description: 'Grade 3',
      shortDescription: 'Grade3',
      listPriority: 6,

      typeName: "CurriculumLevel"
   },
   {
      code: CurriculumLevel_.Grade4,
      literal: 'Grade4',
      description: 'Grade 4',
      shortDescription: 'Grade4',
      listPriority: 7,

      typeName: "CurriculumLevel"
   },
   {
      code: CurriculumLevel_.Grade5,
      literal: 'Grade5',
      description: 'Grade 5',
      shortDescription: 'Grade5',
      listPriority: 8,

      typeName: "CurriculumLevel"
   },
   {
      code: CurriculumLevel_.Grade6,
      literal: 'Grade6',
      description: 'Grade 6',
      shortDescription: 'Grade6',
      listPriority: 9,

      typeName: "CurriculumLevel"
   }
]

export class CurriculumLevel implements IDomainModel {
   code: CurriculumLevel_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: CurriculumLevel_): CurriculumLevel {
      return CurriculumLevels.find(d => d.code === code)
   }
}
